import { Controller } from "@hotwired/stimulus"

/**
 * Simple toggle controller for billing address selection
 * Shows either the default address from DirectSale or a custom form
 */
export default class extends Controller {
  static targets = ["defaultAddress", "customForm", "useDefaultInput"]

  showCustomForm() {
    this.defaultAddressTarget.classList.add("hidden")
    this.customFormTarget.classList.remove("hidden")

    // Update hidden input to indicate custom address is being used
    if (this.hasUseDefaultInputTarget) {
      this.useDefaultInputTarget.value = "false"
    }
  }

  showDefaultAddress() {
    this.customFormTarget.classList.add("hidden")
    this.defaultAddressTarget.classList.remove("hidden")

    // Update hidden input to indicate default address is being used
    if (this.hasUseDefaultInputTarget) {
      this.useDefaultInputTarget.value = "true"
    }

    // Clear custom form fields
    this.customFormTarget.querySelectorAll("input").forEach(input => {
      input.value = ""
    })
  }
}
